import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThreatAdvisorRootProvider } from '@threatadvisor/react-components';
import { SignalRProvider } from '@threatadvisor/react-utils';
import App from './App';

export * from './types';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <ThreatAdvisorRootProvider
      basename="/"
      oidc_authority={import.meta.env.VITE_OIDC_AUTHORITY}
      oidc_client_id="threatadvisor_mdr"
      oidc_scopes="securityevent emailrelay roles"
    >
      <SignalRProvider url={`${import.meta.env.VITE_SECURITYEVENT_API}/securityeventhub`}>
        <App />
      </SignalRProvider>
    </ThreatAdvisorRootProvider>
  </React.StrictMode>
);
